import React from 'react';
import { DropdownProps } from 'react-bootstrap/Dropdown';

interface TouchableDropdownApi {
    dropdown: {
        onMouseEnter(): void;
        onMouseLeave(): void;
        onToggle: DropdownProps['onToggle'];
        onTouchEnd(): void;
        show: boolean;
    };
    menu: {
        onBlur: React.FocusEventHandler<HTMLDivElement>;
    };
}

const useTouchableDropdown = (): TouchableDropdownApi => {
    const [show, setShow] = React.useState(false);
    const ignoreToggle = React.useRef(false);

    return {
        dropdown: {
            onMouseEnter() {
                setShow(true);
            },
            onMouseLeave() {
                setShow(false);
            },
            onToggle(isOpen, _event, { source }) {
                if (ignoreToggle.current || !source) {
                    ignoreToggle.current = false;
                } else {
                    setShow(isOpen);
                }
            },
            onTouchEnd() {
                if (!show) {
                    ignoreToggle.current = true;
                    setShow(true);
                }
            },
            show,
        },
        menu: {
            onBlur({ currentTarget, relatedTarget }) {
                if (!currentTarget.contains(relatedTarget as Node)) {
                    setShow(false);
                }
            },
        },
    };
};

export { useTouchableDropdown };
